<template>
  <Modal
    title="Call Note"
    class-name="call-note-modal small-modal"
    @delete="handleDelete"
    @submit="handleSave"
    @hide-modal="$emit('hide-modal')"
  >
    <div>
      <TextArea
        v-model="callNoteText"
        name="Call Notes"
        :rows="5"
        placeholder="Add some notes...."
        label="Add or Edit Call Note"
      />
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
import Modal from "../components/Modal.vue";
import { EventBus } from "../lib/event_bus.js";

export default {
  components: {
    Modal,
    TextArea
  },
  props: {
    callId: {
      type: Number,
      default: null
    },
    noteText: {
      type: String,
      default: null
    },
    addNotePath: {
      type: String,
      default: null
    },
    removeNotePath: {
      type: String,
      default: null
    }
  },
  emits: ["hide-modal", "save-success"],
  data() {
    return {
      callNoteText: this.noteText
    };
  },
  computed: {
    ...mapState({
      departments: "call_notes"
    })
  },
  mounted() {
    this.callNoteText = this.noteText;
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  methods: {
    ...mapActions(["updateCallNote", "removeCallNote"]),
    handleSave() {
      const noteErrorMessage = "Note cannot be blank";
      if (this.callNoteText == null || this.callNoteText.trim().length == 0) {
        window.notify.error(noteErrorMessage);
        return;
      }

      this.v$.$validate().then((valid) => {
        if (valid) {
          this.updateCallNote({
            addNotePath: this.addNotePath,
            comment: this.callNoteText,
            callId: this.callId
          })
            .then((res) => {
              window.notify.success("Note updated successfully!");
              if (res.data.message) {
                window.notify.success(`${res.data.message}`);
              }
              this.$emit("hide-modal");
              this.$emit("save-success");
              EventBus.$emit("refresh-datatable");
            })
            .catch(() => {
              window.notify.error(noteErrorMessage);
            });
        }
      });
    },

    handleDelete() {
      this.removeCallNote({ removeNodePath: this.removeNotePath }).then(() => {
        EventBus.$emit("refresh-datatable");
        this.$emit("hide-modal");
      });
    }
  }
};
</script>

<style lang="scss">
.job-opportunity-modal {
  .modal-dialog {
    max-width: 500px;
  }
}
</style>
